/**
 * Feature board layout. Signed-in users only (inherited from the `(protected)` group) —
 * there is no public/anonymous board, so no extra gate is needed here beyond the standard
 * session check. Mirrors the shell used by `ops/route.tsx`, minus the SITE_ADMIN guard.
 */
import { Suspense } from 'react'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Loader2 } from 'lucide-react'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/app-sidebar'
import { ScrollArea } from '@/components/ui/scroll-area'

export const Route = createFileRoute('/(protected)/feature-board')({
  component: FeatureBoardLayout,
})

function FeatureBoardLayout() {
  return (
    <Suspense
      fallback={
        <div className="flex h-screen w-screen items-center justify-center">
          <Loader2 className="h-4 w-4 animate-spin" />
        </div>
      }
    >
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset className="h-screen overflow-hidden">
          <ScrollArea className="h-screen" viewClassName="[&>div]:!block">
            <Outlet />
          </ScrollArea>
        </SidebarInset>
      </SidebarProvider>
    </Suspense>
  )
}
